export default function saveInventoryItemActionCreator(savedInventoryDuck, authDuck, personalization) {
  return listing => async (dispatch, getState) => {
    try {
      let savedInventory = typeof getState().toJS === 'function' ? getState().get('savedInventory') : getState().savedInventory;
      const brand = typeof getState().toJS === 'function' ? getState().get('brand') : getState().brand;
      const inventory = savedInventoryDuck.selectors.getSavedInventoryIds({
        savedInventory
      });
      const isLoggedIn = authDuck.selectors.isLoggedIn(getState());
      personalization.setAuthenticated(isLoggedIn);
      const saveEvent = await personalization.saveInventoryItem(listing);
      switch (saveEvent.cacheType) {
        case 'remote':
          {
            dispatch({
              type: savedInventoryDuck.types.ADD_SAVED_INVENTORY_ITEM,
              payload: {
                listingId: listing.id,
                bookmarkId: saveEvent?.bookmark?.id,
                version: saveEvent.version
              }
            });
            if (saveEvent.bookmark?.isSaved) {
              if (!saveEvent.bookmark.isExisting) {
                // update local storage only when save was successful
                inventory.push(listing.id);
                personalization.updateUserProfileCache({
                  carIds: inventory
                });
                dispatch(savedInventoryDuck.creators.showUpdateSavedInventory({
                  listing,
                  bookmark: saveEvent.bookmark,
                  phone: saveEvent.phone
                }));
              }
            } else {
              const message = saveEvent.messages && saveEvent.messages.error;
              dispatch(savedInventoryDuck.creators.setGlobalAlert({
                key: 'serverFailure',
                message
              }));

              // remove locally saved item since we failed
              dispatch({
                type: savedInventoryDuck.types.REMOVE_SAVED_INVENTORY_ITEM,
                payload: listing.id
              });
            }
            break;
          }
        case 'local':
          {
            // re-process state so we can get the most recent values
            savedInventory = typeof getState().toJS === 'function' ? getState().get('savedInventory') : getState().savedInventory;
            const hasMaxQuickSaveItems = savedInventoryDuck.selectors.hasMaxQuickSaveItems({
              savedInventory
            });
            if (hasMaxQuickSaveItems) {
              if (brand === 'kbb') {
                dispatch({
                  type: savedInventoryDuck.types.ADD_SAVED_INVENTORY_ITEM,
                  payload: listing.id
                });
              }
              await personalization.unsaveInventoryItem(listing); // remove listing from local storage
              dispatch(savedInventoryDuck.creators.showQuickSaveNotification());
            } else {
              dispatch({
                type: savedInventoryDuck.types.ADD_SAVED_INVENTORY_ITEM,
                payload: {
                  listingId: listing.id,
                  bookmarkId: ''
                }
              });
            }
            break;
          }
        default:
      }
      return saveEvent;
    } catch (error) {
      throw Error(error);
    }
  };
}